(function () {
  'use strict';

  // Guard against the IIFE running twice if the script tag ever ends up
  // emitted more than once on a page (e.g. from a snippet). Without this,
  // every duplicate load registers another delegated click listener, which
  // causes a single click to toggle the <details> element multiple times —
  // the panel opens, then immediately closes again.
  if (window.__broraAccordionInit) return;
  window.__broraAccordionInit = true;

  // Animation timings (Figma spec)
  const HEIGHT_DURATION = 300;
  const FADE_DURATION = 300;
  const FADE_DELAY = 300;
  const EASING = 'cubic-bezier(0.42, 0, 0.58, 1)'; // ease-both
  const HAS_WAAPI = typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';

  // Icon and title-colour swaps are CSS-driven via the `group-open:` Tailwind
  // variants on the snippet — they react automatically when the `open`
  // attribute on <details> flips. This file only manages the height + fade
  // animations.

  function animateOpen(item) {
    const panel = item.querySelector('[data-accordion-panel]');
    const content = item.querySelector('[data-accordion-content]');
    if (!panel || !content) return;

    if (!HAS_WAAPI) return;

    // Step 1: height 0 → auto, 0.3s ease-both
    const targetHeight = content.offsetHeight;
    panel.animate(
      [{ height: '0px' }, { height: targetHeight + 'px' }],
      { duration: HEIGHT_DURATION, easing: EASING, fill: 'both' }
    );

    // Step 2: content fade in, 0.3s ease-both, 0.3s delay
    content.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: FADE_DURATION, delay: FADE_DELAY, easing: EASING, fill: 'both' }
    );
  }

  function animateClose(item, done) {
    const panel = item.querySelector('[data-accordion-panel]');
    const content = item.querySelector('[data-accordion-content]');
    if (!panel || !content) {
      done();
      return;
    }

    if (!HAS_WAAPI) {
      done();
      return;
    }

    const startHeight = content.offsetHeight;

    // Step 1: content fade out, 0.3s ease-both, no delay
    content.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      { duration: FADE_DURATION, easing: EASING, fill: 'both' }
    );

    // Step 2: height collapse + title/icon revert, 0.3s ease-both, 0.3s delay
    const heightAnim = panel.animate(
      [{ height: startHeight + 'px' }, { height: '0px' }],
      { duration: HEIGHT_DURATION, delay: FADE_DELAY, easing: EASING, fill: 'both' }
    );

    heightAnim.onfinish = done;
  }

  // Closes any sibling that shares the same `name` attribute, mirroring
  // the native exclusive-open behaviour but with our animation.
  function closeSiblings(item) {
    const groupName = item.getAttribute('name');
    if (!groupName) return;
    const siblings = document.querySelectorAll(
      'details[name="' + groupName + '"][data-accordion-item]'
    );
    siblings.forEach(function (sibling) {
      if (sibling !== item && sibling.open) {
        animateClose(sibling, function () {
          sibling.open = false;
        });
      }
    });
  }

  // Intercept summary clicks so we can run animations before/after the
  // native open state flips.
  document.addEventListener('click', function (event) {
    const summary = event.target.closest('[data-accordion-trigger]');
    if (!summary) return;

    const item = summary.closest('[data-accordion-item]');
    if (!item) return;

    event.preventDefault();

    if (item.open) {
      animateClose(item, function () {
        item.open = false;
      });
    } else {
      closeSiblings(item);
      item.open = true;
      requestAnimationFrame(function () {
        animateOpen(item);
      });
    }
  });

  // Keyboard parity: <summary> natively toggles on Enter/Space; the click
  // handler above runs because those keys dispatch click events on summary.
})();
